export interface PortalDrawerItem {
  id: string;
  label: string;
  path: string;
  disabledReason?: string;
}

export const PortalDrawerData: PortalDrawerItem[] = [
  {
    id: "template-bank",
    label: "Template Bank",
    path: "/template-editor/active",
  },
  {
    id: "curate-resources",
    label: "Curate Resources",
    path: "/portal/curate-resources",
  },
  {
    id: "library-lite-cutoff",
    label: "Library Lite Cutoff",
    path: "/portal/library-lite-cutoff",
  },
  {
    id: "library-rollout",
    label: "Library rollout",
    path: "/portal/library-rollout",
  },
  {
    id: "delete-client",
    label: "Delete client",
    path: "/portal/delete-client",
    disabledReason: "This needs to be tested before release",
  },
];
